import React from 'react';
import { Typography, Box, IconButton, Grid } from '@mui/material';
import { styled } from '@mui/system';
import imgUrl from '../assets/images/imgUrl';
import bannerVideo from '../assets/videos/dureBanner.mp4';


// Styled Components
const BackgroundContainer = styled(Box)({
  position: 'relative',
  height: '100vh',
  overflow: 'hidden',
  color: '#fff',
});

const VideoBackground = styled('video')({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  zIndex: -1,
});

const Overlay = styled(Box)({
  position: 'relative',
  padding: '1rem',
  display: 'flex',
  alignItems: 'center',
  height: '100%',
  zIndex: 1,
});

const FloatingChatButton = styled(IconButton)({
  position: 'fixed',
  bottom: 40,
  right: 16,
  zIndex: 99,
});

function Home() {
  return (
    <>
      <BackgroundContainer className="homeBackgroundContainer" id="home">
        {/* Video Background */}
        <VideoBackground autoPlay muted loop playsInline>
          <source src={bannerVideo} type="video/mp4" />
          Your browser does not support the video tag.
        </VideoBackground>

        {/* Content Overlay */}
        <Overlay>
          <Grid container>
            <Grid size={{xs:12 , md:7}}>
              <Typography
                variant="h3"
                fontWeight="bold"
                sx={{
                  fontSize: { xs: '2rem', sm: '2.5rem', md: '4rem' },
                  lineHeight: 1.3,
                  maxWidth: '100%',
                  wordBreak: 'break-word',
                }}
              >
                Democratising data and the power of AI
              </Typography>
            </Grid>
            <Grid size={{xs:12 , md:5}}></Grid>
          </Grid>
        </Overlay>
      </BackgroundContainer>

      <FloatingChatButton>
        <img src={imgUrl.bot} className="w-100 botIcon" alt="Chatbot" />
      </FloatingChatButton>
    </>
  );
}

export default Home;
